// All comments in English.
export default function EmptyState({ text = "No data" }: { text?: string }) {
  return <div className="p-6 text-center text-sm text-gray-500">{text}</div>;
}
